import { useState } from "react";
import { CompanyStampListRequestDto } from "@/dto/CompanyStampDto";

export default function useFilter(
  values: CompanyStampListRequestDto,
  onChange: (values: CompanyStampListRequestDto) => void,
  onReset: () => void
) {
  const [formValues, setFormValues] =
    useState<CompanyStampListRequestDto>(values);

  const handleComNmChange = (value: string) => {
    setFormValues((prev) => ({
      ...prev,
      comNm: value,
    }));
  };

  const handleAdmNmChange = (value: string) => {
    setFormValues((prev) => ({
      ...prev,
      admNm: value,
    }));
  };

  // apis 호출 후 구독 상품 리스트 조회 세팅
  const handleProductIdChange = (value: string) => {
    setFormValues((prev) => ({
      ...prev,
      productId: value,
    }));
  };

  // apis 호출 후 템플릿 리스트 조회 세팅
  const handleTemplateIdChange = (value: string) => {
    setFormValues((prev) => ({
      ...prev,
      templateId: value,
    }));
  };

  const handleSubscriptionStatChange = (
    value: "PENDING" | "ACTIVE" | "CANCELED" | "EXPIRED" | undefined
  ) => {
    setFormValues((prev) => ({
      ...prev,
      subscriptionStat: value,
    }));
  };

  const handleSearch = () => {
    onChange(formValues);
  };

  const handleReset = () => {
    setFormValues(values);
    onReset();
  };

  return {
    formValues,
    handleSearch,
    handleReset,
    handleComNmChange,
    handleAdmNmChange,
    handleProductIdChange,
    handleTemplateIdChange,
    handleSubscriptionStatChange,
  };
}
